/**
 * 登录成功
 * @type {string}
 */
export const EVENT_LOGIN_SUCCESS = 'EVENT_LOGIN_SUCCESS';
export const EVENT_LOGOUT_SUCCESS = 'EVENT_LOGOUT_SUCCESS';
